import z from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalStringArray,
  nullSafeString,
} from '../shared/schema'

export const schema = z.object({
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  minScore: z.coerce.number(),
  maxScore: z.coerce.number(),
  description: nullSafeString(''),
  title: nullSafeString(''),
  scoreDescriptions: z.preprocess(
    (val) => val ?? [],
    z.array(
      z.object({
        score: z.coerce.number(),
        title: nullSafeString(''),
        explanation: nullSafeString(''),
        prompt: nullSafeString(''),
        color: nullSafeString(''),
        longDescription: nullSafeString(''),
        meaning: nullSafeString(''),
      })
    )
  ),
  scoreGrouping: z
    .record(
      z.string(),
      z.object({
        color: z.string(),
        scores: z.array(z.coerce.number()),
      })
    )
    .nullish()
    .optional(),
  requiredPrompts: nullSafeOptionalStringArray(['primaryPrompt']),
  optionalPrompts: nullSafeOptionalStringArray([]),
})

export const empty = Object.freeze(
  schema.parse({
    updatedAt: null,
    minScore: 0,
    maxScore: 0,
    description: '',
    title: '',
    scoreDescriptions: [],
  })
)

export type FirestorePromptRubricType = z.infer<typeof schema>
